import {
  GET_STARTED_BUTTON_TEXT,
  GOALS_TEXT,
  PURPOSE_TEXT,
  RESUME_BUTTON_TEXT,
} from './constants'

/** Maps ?modalId= query (1–4) to `currentPlanStep` used by handleModalClose / stepDataMap. */
export const planStepIndexFromModalQueryParam = modalId => {
  const n = Number(modalId)
  if (Number.isNaN(n) || n < 1 || n > 4) return null
  if (n === 4) return 3
  return n - 1
}

export const getModalButtonText = ({
  modalName,
  goalsIsInDraft,
  purposeIsInDraft,
}) => {
  if (modalName === GOALS_TEXT && goalsIsInDraft) {
    return RESUME_BUTTON_TEXT
  }
  if (modalName === PURPOSE_TEXT && purposeIsInDraft) {
    return RESUME_BUTTON_TEXT
  }
  return GET_STARTED_BUTTON_TEXT
}

export const getActiveStepFromCompletion = ({
  implementationApproachIsCompleted,
  goalsAreCompleted,
  purposeIsCompleted,
}) => {
  const stepConditions = [
    !implementationApproachIsCompleted,
    !goalsAreCompleted,
    !purposeIsCompleted,
  ]
  const newStep = stepConditions.findIndex(condition => condition)
  return newStep > 0 ? newStep : 0
}

export const findPlanPanel = panelData =>
  panelData?.find(({ header }) => header.toLowerCase().includes('plan'))

export const resolveSitePlaybookData = ({ playbookData, siteId }) =>
  playbookData?.find(site => site.site_id === siteId) || playbookData?.[0] || {}

export const resolveAdminK8Site = ({ adminK8Sites, site, siteId }) => {
  if (site) {
    return site
  }

  if (siteId != null && adminK8Sites?.length) {
    const matchedSite = adminK8Sites.find(
      adminSite => String(adminSite.id) === String(siteId),
    )

    if (matchedSite) {
      return matchedSite
    }
  }

  return adminK8Sites?.[0] || {}
}

const K5_SEL_DIGITAL_ACCESS_CODE = 'k5SelDigital'

export const getK5DigitalFromPreferences = preferences => {
  if (!Array.isArray(preferences)) {
    return {}
  }

  return preferences
    .filter(
      pref =>
        pref?.assignmentType === 'Site' &&
        pref?.accessCode === K5_SEL_DIGITAL_ACCESS_CODE,
    )
    .reduce((accumulator, pref) => {
      if (!pref?.name) {
        return accumulator
      }

      const key = pref.name.charAt(0).toLowerCase() + pref.name.slice(1)

      let value = pref.value
      if (pref.valueType === 'Boolean') {
        if (typeof value === 'boolean') {
          // keep as-is
        } else if (value === null || value === undefined) {
          value = null
        } else {
          value = value === 'true' || value === true || value === 1
        }
      }

      accumulator[key] = value
      return accumulator
    }, {})
}
